var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHostingroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 29,
    viewBox: "0 0 14 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M10.945 0H1.53C.685 0 0 .685 0 1.53v24.36c0 .844.685 1.53 1.53 1.53h9.415c.844 0 1.529-.686 1.529-1.53V1.53c0-.845-.685-1.53-1.53-1.53M6.238 9.334c-1.97 0-3.568-1.598-3.568-3.568S4.267 2.2 6.237 2.2s3.568 1.597 3.568 3.567c0 1.97-1.598 3.568-3.568 3.568",
    transform: "translate(.222 .992)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M8.999 22.682c-.347.347-.907.347-1.254 0l-4.27-4.27c-.345-.346-.345-.906 0-1.253.347-.345.908-.345 1.254 0L9 21.43c.346.346.346.907 0 1.253",
    transform: "translate(.222 .992)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M3.476 22.682c-.347-.346-.347-.907 0-1.253l4.27-4.27c.346-.345.907-.345 1.253 0 .346.347.346.907 0 1.254l-4.27 4.27c-.346.346-.907.346-1.253 0M9.557 5.131c0 1.833-1.486 3.32-3.32 3.32-1.833 0-3.319-1.487-3.319-3.32 0-1.833 1.486-3.32 3.32-3.32 1.833 0 3.319 1.487 3.319 3.32",
    transform: "translate(.222 .992)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostingroom);
export default __webpack_public_path__ + "static/media/hostingroom.cb3f2123f658fd243bc46bc189ae47de.svg";
export { ForwardRef as ReactComponent };